import { useState } from "react";
import type { CoreValue } from "../data/coreValues";

interface ValueCardProps {
  value: CoreValue;
}

export default function ValueCard({ value }: ValueCardProps) {
  const [revealed, setRevealed] = useState(false);
  const Icon = value.icon;

  return (
    <div className="group rounded-2xl bg-white p-6 shadow-sm ring-1 ring-ocean-900/5 transition-colors hover:ring-teal-400/30">
      <button type="button" onClick={() => setRevealed((r) => !r)} aria-expanded={revealed} className="w-full text-left">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-400/15 text-teal-500">
          <Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" />
        </div>
        <h3 className="mt-4 font-display font-semibold text-ocean-950">{value.title}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-ocean-800/70">{value.body}</p>
      </button>
      <div
        className={`grid overflow-hidden transition-all duration-300 group-hover:grid-rows-[1fr] group-hover:opacity-100 group-focus-within:grid-rows-[1fr] group-focus-within:opacity-100 ${
          revealed ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <p className="min-h-0 border-t border-teal-400/20 pt-3 text-xs leading-relaxed text-teal-700">
          <span className="font-semibold">In practice: </span>
          {value.example}
        </p>
      </div>
    </div>
  );
}
